export const tiktok = {
  tokenHelp:
    'The token can be found under "Apps and sales channels > Develop Apps"',
  oAuthFlowHelp: "Connect my shop",
  authSuccess: "Authentication successful",
  migrationSuccess: "Successfully acquired tokens from Shopify.",
  helpText:
    "Authenticate with TikTok Shop – You will be redirected to TikTok and brought back to Xentral after successful authentication."
};
